var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "formParam"
  }, [_c("el-form", {
    ref: "updateParam",
    attrs: {
      "label-width": "80px",
      "label-position": "top",
      size: "small"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "参数名称"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.updateParam.paramName,
      callback: function callback($$v) {
        _vm.$set(_vm.updateParam, "paramName", $$v);
      },
      expression: "updateParam.paramName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "参数描述"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.updateParam.paramDesc,
      callback: function callback($$v) {
        _vm.$set(_vm.updateParam, "paramDesc", $$v);
      },
      expression: "updateParam.paramDesc"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "占位提示"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.updateParam.placeholder,
      callback: function callback($$v) {
        _vm.$set(_vm.updateParam, "placeholder", $$v);
      },
      expression: "updateParam.placeholder"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "类型"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.updateParam.type,
      callback: function callback($$v) {
        _vm.$set(_vm.updateParam, "type", $$v);
      },
      expression: "updateParam.type"
    }
  })], 1), _vm.param.type !== "checkbox" ? _c("el-form-item", {
    attrs: {
      label: "默认值"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.updateParam.value,
      callback: function callback($$v) {
        _vm.$set(_vm.updateParam, "value", $$v);
      },
      expression: "updateParam.value"
    }
  })], 1) : _vm._e(), _vm.param.type === "checkbox" ? _c("el-form-item", {
    attrs: {
      label: "默认值"
    }
  }, _vm._l(_vm.updateParam.option, function (item, key) {
    return _c("span", {
      key: key
    }, [item.isChecked && item.isChecked === true ? _c("el-input", {
      attrs: {
        disabled: ""
      },
      model: {
        value: item.label,
        callback: function callback($$v) {
          _vm.$set(item, "label", $$v);
        },
        expression: "item.label"
      }
    }) : _vm._e()], 1);
  }), 0) : _vm._e(), _vm.param.option ? _c("div", [_c("el-divider", [_vm._v("选项")]), _vm._l(_vm.param.option, function (val, key) {
    return _c("div", {
      key: key
    }, [_c("el-row", {
      attrs: {
        gutter: 5
      }
    }, [_c("el-col", {
      attrs: {
        span: 18
      }
    }, [_c("el-input", {
      model: {
        value: val.label,
        callback: function callback($$v) {
          _vm.$set(val, "label", $$v);
        },
        expression: "val.label"
      }
    })], 1), _c("el-col", {
      attrs: {
        span: 4
      }
    }, [_c("el-button", {
      on: {
        click: function click($event) {
          return _vm.removeOption(key);
        }
      }
    }, [_vm._v("删除")])], 1)], 1)], 1);
  }), _c("el-button", {
    on: {
      click: function click($event) {
        return _vm.addOption();
      }
    }
  }, [_vm._v("添加选项")])], 2) : _vm._e(), _c("el-divider"), _c("el-form-item", {
    attrs: {
      label: "是否为主键"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: _vm.updateParam.isPrimaryKey,
      callback: function callback($$v) {
        _vm.$set(_vm.updateParam, "isPrimaryKey", $$v);
      },
      expression: "updateParam.isPrimaryKey"
    }
  }), _vm._v(_vm._s(_vm.updateParam.isPrimaryKey === 0 ? "否" : "是") + " ")], 1), _c("el-form-item", {
    attrs: {
      label: "是否必填"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: _vm.updateParam.isRequired,
      callback: function callback($$v) {
        _vm.$set(_vm.updateParam, "isRequired", $$v);
      },
      expression: "updateParam.isRequired"
    }
  }), _vm._v(_vm._s(_vm.updateParam.isRequired === 0 ? "否" : "是") + " ")], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };